import { useRef, useState } from "react";
import { cn } from "../../../../../lib/cn.js";

export default function AdminSelectCustomerList({
    title = "آپلود فایل",
    onSelectFile,
}: {
    title?: string;
    onSelectFile: (file: File) => void;
}) {
    const InputRef = useRef<HTMLInputElement | null>(null);
    const [error, setISError] = useState<boolean>(false);
    const [fileName, setFileName] = useState<string>("");
    function handleSelectFile(e: React.ChangeEvent<HTMLInputElement>) {
        const file = e.target.files;
        if (file && file.length > 0) {
            const selectedFile = file[0];
            const maxSize = 10 * 1024 * 1024;
            const allowedType = [
                "application/vnd.ms-excel",                                              // XLS (قدیمی)
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",     // XLSX (جدید)
                "image/jpeg",   
            ]
            if (selectedFile) {
                if (!allowedType.includes(selectedFile?.type)) {
                    // toastify('error', 'فایل انتخابی باید عکس باشد')
                    setISError(true);
                } else if (selectedFile.size > maxSize) {
                    setISError(true);
                } else {
                    setISError(false);
                    // const imageUrl = URL.createObjectURL(selectedFile);
                    onSelectFile(selectedFile);
                    setFileName(selectedFile.name);
                }
            }
        }
    }
    return (
        <div className="w-full">
            <div
                className={cn(
                    error && "!border-red-300  !bg-red-50",
                    fileName && !error && "!border-green-300  !bg-green-50",
                    "border-dashed  rounded-xl border-[1.8px] select-none cursor-pointer border-brand-300 bg-brand-50 mt-5 p-5 flex flex-col items-center justify-center gap-2",
                )}
                onClick={() => InputRef.current?.click()}
            >
                <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.6673 6.33333H9.50065C8.6608 6.33333 7.85534 6.66696 7.26148 7.26083C6.66761 7.85469 6.33398 8.66015 6.33398 9.5V28.5C6.33398 29.3399 6.66761 30.1453 7.26148 30.7392C7.85534 31.333 8.6608 31.6667 9.50065 31.6667H28.5007C29.3405 31.6667 30.146 31.333 30.7398 30.7392C31.3337 30.1453 31.6673 29.3399 31.6673 28.5V9.5C31.6673 8.66015 31.3337 7.85469 30.7398 7.26083C30.146 6.66696 29.3405 6.33333 28.5007 6.33333H25.334M19.0007 4.75V17.4167M14.2507 12.6667L19.0007 17.4167L23.7507 12.6667M6.33398 20.5833H10.4285C10.8484 20.5834 11.251 20.7503 11.5479 21.0472L15.3701 24.8694C15.6669 25.1664 16.0696 25.3332 16.4895 25.3333H21.5118C21.9317 25.3332 22.3344 25.1664 22.6312 24.8694L26.4534 21.0472C26.7503 20.7503 27.1529 20.5834 27.5728 20.5833H31.6673" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

                <p className="font-bold text-lg">{title}</p>
                <p className="text-black/60">
                    {error && "پسوند XLS با حداکثر حجم 2 مگ"}
                    {!error && !fileName && "پسوند XLS با حداکثر حجم 2 مگ"}
                    {!error && fileName && fileName}
                </p>
            </div>
            {/* {errors.file && touched.file && (
        <p className="text-sm  text-red-600 pt-2">{errors.file}</p>
      )} */}
            <input
                className="hidden"
                onChange={(e) => handleSelectFile(e)}
                type="file"
                ref={InputRef}
            />
        </div>
    );
}
